<template>
    <section class="card hero is-info welcome is-small is-fullwidth">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Hello, {{ userName }}.
                </h1>
                <h2 class="subtitle">
                    I hope you are having a great day!
                </h2>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                userName: this.$store.getters.getUserName
            }
        },
    }
</script>

<style scoped>
    .hero.welcome.is-info {
        background: #36D1DC;
        background: -webkit-linear-gradient(to right, #5B86E5, #36D1DC);
        background: linear-gradient(to right, #5B86E5, #36D1DC);
    }
    .hero.welcome .title, .hero.welcome .subtitle {
        color: hsl(192, 17%, 99%);
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Welcome.vue